/**
* @Author: zachalam
* @Date:   2017-02-22T14:07:49-08:00
* @Email:  zach@reflexmedia.com
* @Last modified by:   zachalam
* @Last modified time: 2017-02-22T14:07:49-08:00
*/


let initialState = {

};

const settings = (state = initialState, action) => {
  switch(action.type) {
    case 'STORE_SETTINGS':
      return {
        ...state,
        ...action.payload
      }
    case 'INVERT_SETTING':
      // invert a setting value when clicked (checkbox on settings page).
      let newState = Object.assign({},state);
      newState[action.payload] = !state[action.payload];
      return newState;

    default:
      return state;
  }
}



export default settings;



// WEBPACK FOOTER //
// ./src/reducers/settings.js